import type { FC } from 'react';

import { useContent } from '@eneco/cms';
import { Grid, Heading, Stack, Text } from '@eneco/sparky';

import type { FeatureGridContent } from './feature-grid-content.types';
import { gridColumns } from './gridColumns';

/**
 * `featureGrid` block for the CMS-agnostic lane. POC-schema-only (see `feature-grid-content.types.ts`)
 * — a flat list of title/description pairs, no images or links, so no `adapter.*` mapping is needed.
 */
const FeatureGrid: FC = () => {
  const content = useContent<FeatureGridContent>();
  const features = content.features ?? [];

  if (features.length === 0) return null;

  return (
    <Stack gap="6">
      {content.title && <Heading as="h2">{content.title}</Heading>}
      {content.subtitle && <Text color="textSecondary">{content.subtitle}</Text>}
      <Grid columns={{ initial: 1, md: gridColumns(features.length) }} gap="6">
        {features.map(feature => (
          <Stack key={feature._key} gap="2">
            {feature.title && (
              <Heading as="h3" size="XS">
                {feature.title}
              </Heading>
            )}
            {feature.description && <Text>{feature.description}</Text>}
          </Stack>
        ))}
      </Grid>
    </Stack>
  );
};

export default FeatureGrid;
